var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBezier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 32.6667H9.33333C8.04467 32.6667 7 33.7114 7 35.0001V39.6667C7 40.9554 8.04467 42.0001 9.33333 42.0001H14C15.2887 42.0001 16.3333 40.9554 16.3333 39.6667V35.0001C16.3333 33.7114 15.2887 32.6667 14 32.6667Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.666 32.6667H41.9993C40.7107 32.6667 39.666 33.7114 39.666 35.0001V39.6667C39.666 40.9554 40.7107 42.0001 41.9993 42.0001H46.666C47.9547 42.0001 48.9993 40.9554 48.9993 39.6667V35.0001C48.9993 33.7114 47.9547 32.6667 46.666 32.6667Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 14H25.6673C24.3787 14 23.334 15.0447 23.334 16.3333V21C23.334 22.2887 24.3787 23.3333 25.6673 23.3333H30.334C31.6226 23.3333 32.6673 22.2887 32.6673 21V16.3333C32.6673 15.0447 31.6226 14 30.334 14Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 19.8333C20.2288 20.35 17.3894 21.8974 15.2728 24.2257C13.1561 26.5541 11.8855 29.5276 11.666 32.6666",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.666 19.8333C35.7699 20.35 38.6093 21.8974 40.7259 24.2257C42.8426 26.5541 44.1132 29.5276 44.3327 32.6666",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 18.6667H9.33398",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.666 18.6667H32.666",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 20.9999C8.28801 20.9999 9.33268 19.9552 9.33268 18.6666C9.33268 17.3779 8.28801 16.3333 6.99935 16.3333C5.71068 16.3333 4.66602 17.3779 4.66602 18.6666C4.66602 19.9552 5.71068 20.9999 6.99935 20.9999Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9993 20.9999C50.288 20.9999 51.3327 19.9552 51.3327 18.6666C51.3327 17.3779 50.288 16.3333 48.9993 16.3333C47.7107 16.3333 46.666 17.3779 46.666 18.6666C46.666 19.9552 47.7107 20.9999 48.9993 20.9999Z",
    stroke: "#D8D8EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBezier);
export default __webpack_public_path__ + "static/media/bezier.5a5bb10f1960c41d637d760b57d074ad.svg";
export { ForwardRef as ReactComponent };